import React from 'react';

import styled from 'styled-components';

import { useCommunityInfoContext } from 'components/CommunityInfo/CommunityInfoContext';
import { FEES_DATA_TEST_ATTR } from 'constants/fees';
import { generateFeesDataTestId } from 'helpers/tests';
import { isNonNegativeNumber } from 'utils/helpers/numbers';

import ItemViewHistory from './ItemViewHistory';
import { HistoryItemDataType } from '../../types';
import { useCareTypesContext } from '../CareTypesContext';
import { ITEM_VIEW_HISTORY_CLASS } from '../constants';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  &:hover ${`.${ITEM_VIEW_HISTORY_CLASS}`} {
    opacity: 1;
    visibility: visible;
  }
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitleContainer = styled.div`
  display: flex;
  gap: 4px;
`;

const Title = styled.div`
  font-size: 14px;
  font-family: var(--font-bold);
`;

const Amount = styled.div`
  font-size: 14px;
  color: var(--positive-green);
`;

const Subtitle = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
`;

type Props = {
  history?: HistoryItemDataType;
  field: string;
  title: string;
  amount?: number;
  subtitle?: string;
};

const FeesItem = ({ history, field, title, amount, subtitle }: Props) => {
  const { careType } = useCareTypesContext();
  const { setHistory } = useCommunityInfoContext();
  return (
    <Container data-test-id={generateFeesDataTestId(field)}>
      <Row>
        <TitleContainer>
          <Title data-test-id={generateFeesDataTestId(field, FEES_DATA_TEST_ATTR.TITLE)}>{title}</Title>
          {Boolean(history) && (
            <ItemViewHistory
              data-test-id={generateFeesDataTestId(field, FEES_DATA_TEST_ATTR.HISTORY)}
              onClick={() => setHistory(history)}
            />
          )}
        </TitleContainer>
        {isNonNegativeNumber(amount) && (
          <Amount data-test-id={generateFeesDataTestId(field, FEES_DATA_TEST_ATTR.VALUE)}>
            ${amount?.toLocaleString(undefined, { maximumFractionDigits: 0 })}
          </Amount>
        )}
      </Row>
      <Row>
        <Subtitle data-test-id={generateFeesDataTestId(field, FEES_DATA_TEST_ATTR.TYPE)}>{careType?.type}</Subtitle>
        {subtitle && (
          <Subtitle data-test-id={generateFeesDataTestId(field, FEES_DATA_TEST_ATTR.NOTE)} style={{ textAlign: 'end' }}>
            {subtitle}
          </Subtitle>
        )}
      </Row>
    </Container>
  );
};

export default FeesItem;
